'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _navigation = require('./navigation');

var _navigation2 = _interopRequireDefault(_navigation);

var _tracking = require('./tracking');

var _tracking2 = _interopRequireDefault(_tracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  navigation: _navigation2['default'],
  tracking: _tracking2['default']
};


//////////////////
// WEBPACK FOOTER
// ./program/frontend/reducers/index.js
// module id = 867
// module chunks = 0